<template>
  <v-container fluid>
    <v-row v-if="tutor">
      <v-col cols="12" md="6">
        <v-card>
          <v-toolbar dense flat color="blur">Base info</v-toolbar>
          <v-divider/>
          <v-list>
            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-account</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Nickname</v-list-item-subtitle>
                <v-list-item-title>{{ tutor.nickname }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-email</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Sign-in email</v-list-item-subtitle>
                <v-list-item-title>{{ tutor.email }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-map-marker</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Address</v-list-item-subtitle>
                <v-list-item-title>{{ tutor.country }} {{ tutor.address }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-video</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Zoom Personal Meeting ID</v-list-item-subtitle>
                <v-list-item-title>{{ tutor.zoom_id }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-linkedin</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>LinkedIn</v-list-item-subtitle>
                <v-list-item-title>{{ tutor.linked_in }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset/>

            <v-list-item>
              <v-list-item-icon><v-icon color="success">mdi-skype</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Skype</v-list-item-subtitle>
                <v-list-item-title>{{ tutor.skype }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Practice areas</v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-select label="Practice areas" v-model="tutor.practice_areas"
                      :items="practice_areas"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      @change="updateTutorPracticeAreas"
            ></v-select>
          </v-card-text>
        </v-card>
        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Session types</v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-select label="Session types" v-model="tutor.session_types"
                      :items="session_types"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      @change="updateTutorSessionTypes"
            ></v-select>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Summary</v-toolbar>
          <v-divider/>
          <v-card-text class="ql-editor" v-html="tutor.summary"></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    tutor: {
      type: Object,
      default: null
    }
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    })
  },
  mounted() {

  },
  methods: {
    updateTutorSessionTypes(payload) {
      this.axios.put(`api/tutors/${this.$route.params.tutor_id}`, { session_types: payload})
        .then(() => {this.$emit('loadTutor')})
    },
    updateTutorPracticeAreas(payload) {
      this.axios.put(`api/tutors/${this.$route.params.tutor_id}`, { practice_areas: payload})
        .then(() => {this.$emit('loadTutor')})
    }
  }

}
</script>
